import React from 'react';
import './Hero.style.css';
import { SearchCar } from '../SearchCar/SearchCar';
import { Header } from '../Header/Header';

export const Hero = () => {
  return (
    <>
      <Header />
      <section id="hero" className="hero">
        <div className="hero__container">
          <SearchCar />
        </div>
      </section>
    </>
  );
};
